import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';
import { Router, RoutesRecognized } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { UtilsService } from '../utils.service';
import { filter, pairwise } from 'rxjs/operators';
import { CartService } from '../cart.service';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  private window;
  previousUrl!: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,

    private _windowRef: WindowReferenceService,
    private cartService: CartService,
    private utils: UtilsService,
    private location: Location,
    private router: Router
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.window = _windowRef.nativeWindow;
    }
    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
      });

  }

  public getPreviousUrl() {
    return this.previousUrl;
  }
  public pingHome(obj: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (obj && this.window && this.window.dataLayer) {
        this.window.dataLayer.push({ ecommerce: null });
        this.window.dataLayer.push(obj);
      }
    }
  }

  addToCart(event_type: string, data?: any) {
    const hit = {
      event: event_type,
      ...data,
    };
    this.pingHome(hit);
  }

  triggerEvents(itemArray: any, eventName: string) {
    if (isPlatformBrowser(this.platformId)) {
      let couponData;

    let obj: any = {};
    obj.ecommerce = {};
    obj = {
      event: eventName,
      //'Client_Id': '{{dynamic}}',
      previous_page_path: this.getPreviousUrl() || 'NA', //it should pass the url of previous page
      User_Id: this.utils.getToken() ? localStorage.getItem('email') : 'NA', // Example:- if user is non_loggedin than pass NA in user_id
      loggedin_status: this.utils.getToken() ? 'loggedin' : 'non_loggedin', // Example:- loggedin/non_loggedin if user is non loggedin than pass non_loggedin
      ecommerce: {
        items: itemArray,
      },
    };
    if (
      eventName == 'begin_checkout' ||
      eventName == 'add_shipping_info' ||
      eventName == 'add_payment_info'
    ) {
      this.utils.discountCouponData.subscribe((data:any) => {
        couponData = data;
      });
      obj['coupon'] =
        couponData && Object.keys(couponData).length !== 0
          ? couponData['couponCode']
          : 'NA';
    }
    this.pingHome(obj);
  }
}
  triggerSelectItem(item: any, eventName: any) {
    const productInfo = JSON.parse(this.utils.getProductInfo());
    let itemArray = [];
    itemArray = [
      {
        item_id: item.productSku,
        item_name: item.productName,
        item_brand: productInfo?.seriesName || 'NA',
        currency: 'INR',
        discount: item.productDiscountedPrice !== 0 ? (item.productPrice - item.productDiscountedPrice) : 0,
        item_category: (productInfo && productInfo.category) ? productInfo.category : 'NA',
        item_category2: productInfo?.brandSubCategoriesMenus?.subCategory || 'NA',
        item_category4: item.vaRating || '', //Product Rating. Example 900 VA
        item_category5: item.technology || '', //Product Technology
        price: item.productDiscountedPrice !== 0 ? item.productDiscountedPrice : item.productPrice,

        item_list_name: 'NA', //List Name of section. Example
        item_list_id: 'NA', // Unique list id for every section.
        item_variant: item.warranty || '', // Warranty of Item. Example
        index: 0,
      },
    ];
    this.triggerEvents(itemArray, eventName);
  }

  triggerPromotionEvents(item: any, eventName: string) {
    let itemArray = [];
    if (Array.isArray(item)) {
      itemArray = item.map((data: any, index: number) => {
        return {
          promotion_id: item[index].guidId ? item[index].guidId : '',
          promotion_name: item[index].filename ? item[index].filename : '',
          creative_name: item[index].isSmallBanner == true ? 'small banner' : 'main banner',
          creative_slot: item[index].creativeSlot,
        }
      }
      )
    }
    else {
      itemArray = [
        {
          promotion_id: item.guidId ? item.guidId : '',
          promotion_name: item.filename ? item.filename : '',
          creative_name: item.isSmallBanner == true ? 'small banner' : 'main banner',
          creative_slot: 1,
        },
      ];
    }

    this.triggerEvents(itemArray, eventName);
  }

  triggerCartEvents(eventName: string, productData?: any) {
    if (isPlatformBrowser(this.platformId)) {
      let itemArray = [];
      const cartObservable = localStorage.getItem('buyNow')
        ? this.cartService.buyNowData$
        : this.cartService.cartData$;

      let cartInfo$: any[] = [];

    cartObservable.subscribe((data: any) => {
      cartInfo$ = data || [];
    });


      const productInfo = JSON.parse(this.utils.getProductInfo());

      itemArray = cartInfo$.map((data: any, index: number) => {
        return {
          item_id: data?.productSku || '',
          item_name: data.productName || '',
          item_brand: productInfo?.seriesName || '',
          currency: 'INR',
          discount: data.sellingPrice ? (data.productMRP - data.sellingPrice) * data.quantity : 0,
          item_category: productInfo?.category || 'NA',
          item_category2: productInfo?.brandSubCategoriesMenus?.subCategory || 'NA',
          item_category4: data.specificationList && data.specificationList.length > 0
            ? (data.specificationList.find((element: any) => element.description === 'VA Rating')?.value || 'NA')
            : 'NA',
          item_category5: data.specificationList && data.specificationList.length > 0
            ? (data.specificationList.find((element: any) => element.description === 'Technology')?.value || 'NA')
            : 'NA',
          price: data.sellingPrice ? data.sellingPrice : data.productMRP,
          item_list_name: 'NA',
          item_list_id: 'NA',
          item_variant: data.specificationList && data.specificationList.length > 0
            ? (data?.specificationList.find((element: any) => element.description === 'Warranty')?.value || 'NA')
            : '',
          quantity: data.quantity || 0,
        };
      });

      if (productData && productData !== undefined) {
        let prodData: any = {};
        prodData = {
          item_id: productData?.productSku || '',
          item_name: productData.productName || '',
          item_brand: productInfo?.seriesName || '',
          currency: 'INR',
          discount: productData.sellingPrice ? (productData.productMRP - productData.sellingPrice) * productData.quantity : 0,
          item_category: productInfo?.category || 'NA',
          item_category2: productInfo?.brandSubCategoriesMenus?.subCategory || 'NA',
          item_category4: productData.specificationList && productData.specificationList.length > 0
            ? (productData.specificationList.find((element: any) => element.description === 'VA Rating')?.value || 'NA')
            : 'NA',
          item_category5: productData.specificationList && productData.specificationList.length > 0
            ? (productData.specificationList.find((element: any) => element.description === 'Technology')?.value || 'NA')
            : 'NA',
          price: productData.sellingPrice ? productData.sellingPrice : productData.productMRP,
          item_list_name: 'NA',
          item_list_id: 'NA',
          item_variant: productData.specificationList && productData.specificationList.length > 0
            ? (productData?.specificationList.find((element: any) => element.description === 'Warranty')?.value || 'NA')
            : '',
          quantity: productData.quantity || 0,
        };
        itemArray.push(prodData);
      }

      this.triggerEvents(itemArray, eventName);
    }
  }

  getItemCategory(data: any, key: any) {
    let specifiedData = data.specificationList.find(
      (element: any) => element.description == key
    ).value || 'NA'
    return specifiedData;
  }

  triggerCheckoutEvent(ecommerceData: any, eventName: string) {
    if (isPlatformBrowser(this.platformId)) {

      let obj: any = {};
      obj = {
        'event': eventName,
        //'Client_Id': '{{dynamic}}',
        'previous_page_path': this.getPreviousUrl() || 'NA', //it should pass the url of previous page
        'User_Id': this.utils.getToken() ? localStorage.getItem('email') : 'NA', // Example:- if user is non_loggedin than pass NA in user_id
        'loggedin_status': this.utils.getToken() ? 'loggedin' : 'non_loggedin', // Example:- loggedin/non_loggedin if user is non loggedin than pass non_loggedin
        'ecommerce': ecommerceData
      }
      this.pingHome(obj)
    }
  }
  triggerAddRemoveEvent(eventName: any, data: any) {
    const productInfo = JSON.parse(this.utils.getProductInfo());
    let itemArray: any = [];
    itemArray = [{
      item_id: data?.productSku || '',
      item_name: data.productName || '',
      item_brand: productInfo?.seriesName || '',
      currency: 'INR',
      discount: data.sellingPrice ? (data.productMRP - data.sellingPrice) * data.quantity : 0,
      item_category: productInfo?.category || 'NA',
      item_category2: productInfo?.brandSubCategoriesMenus.subCategory || 'NA',
      item_category4: data.specificationList && data.specificationList.length > 0
        ? (data.specificationList.find((element: any) => element.description === 'VA Rating')?.value || 'NA')
        : 'NA',
      item_category5: data.specificationList && data.specificationList.length > 0
        ? (data.specificationList.find((element: any) => element.description === 'Technology')?.value || 'NA')
        : 'NA',
      price: data.sellingPrice ? data.sellingPrice : data.productMRP,
      item_list_name: 'NA',
      item_list_id: 'NA',
      item_variant: data.specificationList && data.specificationList.length > 0
        ? (data?.specificationList.find((element: any) => element.description === 'Warranty')?.value || 'NA')
        : '',
      quantity: 1,
    }]

    this.triggerEvents(itemArray, eventName);
  }

  }

